/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Set_ModeInputs */

const cs_billing_set_mode = /** @type {(inputs: Billing_Set_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavit režim`)
};

const en_billing_set_mode = /** @type {(inputs: Billing_Set_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set billing mode`)
};

/**
* | output |
* | --- |
* | "Set billing mode" |
*
* @param {Billing_Set_ModeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_set_mode = /** @type {((inputs?: Billing_Set_ModeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Set_ModeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_set_mode(inputs)
	return cs_billing_set_mode(inputs)
});